import { render } from "./ColorPicker.vue?vue&type=template&id=422377ce&scoped=true&ts=true"
import script from "./ColorPicker.vue?vue&type=script&lang=ts"
export * from "./ColorPicker.vue?vue&type=script&lang=ts"

import "./ColorPicker.vue?vue&type=style&index=0&id=422377ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422377ce"]])

export default __exports__